export default "__VITE_ASSET__Mj0cKHRg__"